/*
 * Nubio parallax
 * - Hero: image drifts slower than the page, the display word rises faster, content lifts and fades.
 * - Section images (image banner, image with text, collage, multicolumn, or anything with
 *   [data-nubio-parallax]) shift gently inside their frames as they cross the viewport.
 * Off for prefers-reduced-motion. One passive scroll listener, work done in requestAnimationFrame.
 */
(function () {
  if (window.__nubioParallax) return;
  window.__nubioParallax = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var IMAGE_SELECTORS = [
    '[data-nubio-parallax]',
    // Skip media that already use Dawn's fixed / zoom / ambient image behaviours.
    '.banner__media:not(.animate--fixed):not(.animate--zoom-in):not(.animate--ambient) > img',
    '.image-with-text__media:not(.animate--fixed):not(.animate--zoom-in):not(.animate--ambient) > img',
    '.collage-card .media > img',
    '.multicolumn-card__image-wrapper .media > img',
  ].join(',');

  var heroes = [];
  var images = [];
  var ticking = false;
  var vh = window.innerHeight;

  function clamp(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  function setHeroOffset(hero) {
    // Make the hero fill exactly what's left of the first screen below the header and bars.
    var section = hero.closest('.shopify-section');
    var main = document.querySelector('main');
    var isFirst = section && main && main.firstElementChild === section;
    var top = isFirst ? hero.getBoundingClientRect().top + window.scrollY : 0;
    hero.style.setProperty('--nubio-hero-offset', Math.max(0, Math.round(top)) + 'px');
  }

  function collect() {
    heroes = Array.prototype.map.call(document.querySelectorAll('[data-nubio-hero]'), function (el) {
      setHeroOffset(el);
      return {
        el: el,
        strength: parseFloat(el.getAttribute('data-parallax-strength') || '0.5'),
        media: el.querySelector('[data-hero-layer="media"]'),
        word: el.querySelector('[data-hero-layer="word"]'),
        content: el.querySelector('[data-hero-layer="content"]'),
      };
    });

    images.forEach(function (img) {
      img.classList.remove('nb-parallax-img');
      img.style.removeProperty('--nb-py');
    });
    images = reduceMotion.matches ? [] : Array.prototype.slice.call(document.querySelectorAll(IMAGE_SELECTORS));
    images.forEach(function (img) {
      img.classList.add('nb-parallax-img');
    });
  }

  function resetHero(h) {
    [h.media, h.word, h.content].forEach(function (el) {
      if (el) {
        el.style.transform = '';
        el.style.opacity = '';
      }
    });
  }

  function update() {
    ticking = false;
    var motionOff = reduceMotion.matches;

    heroes.forEach(function (h) {
      if (motionOff || !h.strength) return resetHero(h);
      var rect = h.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var height = rect.height || 1;
      var p = clamp(-rect.top / height, 0, 1);
      var s = h.strength;
      if (h.media) h.media.style.transform = 'translate3d(0,' + (p * height * 0.24 * s).toFixed(1) + 'px,0)';
      if (h.word) h.word.style.transform = 'translate3d(0,' + (-p * height * 0.45 * s).toFixed(1) + 'px,0)';
      if (h.content) {
        h.content.style.transform = 'translate3d(0,' + (-p * height * 0.18 * s).toFixed(1) + 'px,0)';
        h.content.style.opacity = clamp(1 - p * 1.8, 0, 1).toFixed(3);
      }
    });

    images.forEach(function (img) {
      var frame = img.parentElement || img;
      var rect = frame.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) return;
      var centre = rect.top + rect.height / 2;
      var offset = clamp((centre - vh / 2) / vh, -1, 1); // -1 above centre, 1 below
      img.style.setProperty('--nb-py', (offset * 6).toFixed(2) + '%');
    });
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init() {
    vh = window.innerHeight;
    collect();
    update();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', function () {
    vh = window.innerHeight;
    heroes.forEach(function (h) {
      setHeroOffset(h.el);
    });
    requestUpdate();
  });
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', init);

  // Theme editor: re-run when sections are added, edited or reordered.
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      window.requestAnimationFrame(init);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
